// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PorterStoreOrderRepo from "./PorterStoreOrderRepo.bs.js";

function getRepo(param) {
  return PorterStoreOrderRepo.PorterStoreOrderRepo;
}

export {
  getRepo ,
  
}
/* PorterStoreOrderRepo Not a pure module */
